import React from 'react';
import { Headline, Text } from '../index.js';
import { RichtextTextLink } from './components/text-link.js';
import { StyledMarkdown } from './index.styles.js';
import {} from 'markdown-to-jsx';
import {} from '@oneaudi/unified-web-common';
import { pickA11yProps } from '../../utils/pick-a11y-props.js';
import { pickDataProps } from '../../utils/pick-data-props.js';
export const RichText = ({ markdown, className, wrapperElement, customOverrides, forceBlock, lang, margin, ...rest }) => {
    const overrides = {
        p: {
            props: {
                lang
            },
            component: Text
        },
        span: {
            props: {
                tag: 'span',
                lang,
                variant: { order: '1', style: 'normal' }
            },
            component: Text
        },
        div: {
            props: {
                tag: 'div',
                lang,
                variant: { order: '1', style: 'normal' }
            },
            component: Text
        },
        a: {
            component: RichtextTextLink
        },
        h1: {
            props: {
                tag: 'h1',
                variant: { type: 'headline', order: '1', weight: 'normal' }
            },
            component: Headline
        },
        h2: {
            props: {
                tag: 'h2',
                variant: { type: 'headline', order: '2', weight: 'normal' }
            },
            component: Headline
        },
        h3: {
            props: {
                tag: 'h3',
                variant: { type: 'headline', order: '3', weight: 'normal' }
            },
            component: Headline
        },
        h4: {
            props: {
                tag: 'h4',
                variant: { type: 'headline', order: '4', weight: 'normal' }
            },
            component: Headline
        }
    };
    const a11yProps = pickA11yProps(rest);
    const dataProps = pickDataProps(rest);
    return (React.createElement(StyledMarkdown, { options: {
            forceBlock,
            overrides: { ...overrides, ...customOverrides },
            wrapper: wrapperElement
        }, className: className, "$margin": margin, ...a11yProps, ...dataProps }, markdown));
};
//# sourceMappingURL=index.js.map